import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import React, { Suspense } from "react"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { QueryErrorBoundary } from "../../../../../core/api/components/QueryErrorBoundary"
import { LoadingSpinner } from "../../../../../shared/components/loading/LoadingSpinner"
import { ServiceCenterProfileContent } from "../components/ServiceCenterProfileContent"

export function ServiceCenterProfile() {
    return (
        <>
            <LocalizedStrict id="profile-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SERVICE_CENTER_ACCOUNT}
                    title="User account"
                    icon={<FontAwesomeIcon icon={faInfoCircle} />}
                />
            </LocalizedStrict>
            <QueryErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                    <ServiceCenterProfileContent />
                </Suspense>
            </QueryErrorBoundary>
        </>
    )
}
